import React from "react";
import { StyledHandle } from "./KgFlowHandle.styles";
import type { KgFlowHandleProps } from "./KgFlowHandle.types";

/**
 * Thin wrapper around `@xyflow/react` `Handle` with KG styling.
 */
export const KgFlowHandle: React.FC<KgFlowHandleProps> = ({
  visible = false,
  ...props
}) => <StyledHandle {...props} $visible={visible} />;

export { StyledHandle as KgFlowHandleVisual } from "./KgFlowHandle.styles";

export default KgFlowHandle;
